import React, {useState, useEffect} from "react"
import ShelfApi from "~/utils/ShelfApi.js"
import TextField from "@material-ui/core/TextField"
import Box from "@material-ui/core/Box"
import Button from "~/components/Button"
import {useDebouncedValue} from "../../hooks"

export const ShoppingCartQuantityBox = ({row, onUpdateQuantity}) => {
  const [error, setError] = useState("")
  const [quantity, setQuantity] = useState(row.quantity)

  const debouncedQuantity = useDebouncedValue(quantity, 500)

  const handleQuantity = value => {
    if (isNaN(parseInt(value)) || parseInt(value) < 1) {
      setQuantity(1)
    } else {
      setQuantity(parseInt(value))
    }
  }

  useEffect(() => {
    if (row.quantity !== quantity) {
      updateQuantity(row.id, debouncedQuantity)
    }
  }, [debouncedQuantity])

  const updateQuantity = (shoppingCartItemId, quantity) => {
    ShelfApi.put(`/product_in_carts/${shoppingCartItemId}/`, {quantity})
      .then(res => onUpdateQuantity())
      .catch(e => {
        setError("Fehler beim aktualisieren des Warenkorb.")
      })
  }

  return (
    <Box flexDirection="row" display="flex" alignItems="center">
      <Button
        onClick={() => {
          if (quantity > 1) {
            handleQuantity(quantity - 1)
          }
        }}
        label="–"
        primary
      />
      <TextField
        inputProps={{
          style: {
            padding: 10,
            textAlign: "center"
          }
        }}
        style={{margin: 5, minWidth: 40, maxWidth: 60}}
        value={quantity || row.quantity}
        id="outlined-basic"
        variant="outlined"
        onChange={e => {
          handleQuantity(e.target.value)
        }}
      />

      <Button
        onClick={() => {
          handleQuantity(quantity + 1)
        }}
        label="+"
        primary
      />
    </Box>
  )
}



// WEBPACK FOOTER //
// ./src/components/domain/ShoppingCartQuantityBox.js